<template>
  <main>
    <div class="gp-main-body-content">
      <Modal :hideExit="true" cClass="mw424">
        <template #header>
          <p class="typo-heading20 typo-medium text-light-high">Forgot Password</p>
        </template>
        <template #default>
          <form ref="form" @submit.prevent="requestChangePassword">
            <p class="text-light-low typo-paragraph14 typo-regular-150 mb-2">Enter your email and we will send a redirect link to reset your password</p>
            <div class="form-group">
              <label class="label typo-button14 typo-medium text-light-high">{{ $t("generals.email") }}</label>
              <input class="input-field input-field-block" :class="{ 'is-error': alertText && alertText.length }" type="email" required v-focus :title="$t('generals.email')" placeholder="chris@gempages.help" v-model="username" />
              <p v-if="alertText" class="typo-paragraph12 typo-italic text-danger mt-half">{{ alertText }}</p>
            </div>

            <div class="btn-group flex-row-reverse mt-4 pos-relative">
              <div class="floating-text pos-absolute" v-if="countDown && countDown > 0">
                <p class="text-light-disabled typo-paragraph12 typo-italic">Try again in {{ countDown | timeify }}</p>
              </div>
              <ProcessButton :key="1" class="btn btn-primary btn-default ml-1" type="submit" :status.sync="btnStatus" :disabled="countDown > 0">
                <template #loading>Sending ...</template>
                <template #success>Sent</template>
                <template #error>Failed</template>
                <template #default>{{ $t("generals.send") }}</template>
              </ProcessButton>
              <button class="btn btn-outline btn-default" type="button" @click="window.location.href = '/'">{{ $t("generals.cancel") }}</button>
            </div>
          </form>
        </template>
      </Modal>
    </div>

    <PortalTarget name="modals" multiple></PortalTarget>
  </main>
</template>

<script>
import { Api, ApiUrl } from "@/services";
import ProcessButton from "@/core/shared/ProcessButton.vue";

const DELAY_TIME = 60;
const prefixier = value => {
  if (value < 10) return "0" + value;
  return "" + value;
};

export default {
  name: "AgencyForgot",
  components: {
    ProcessButton
  },
  filters: {
    timeify(sec) {
      if (sec < 0 || !sec) {
        return "00:00";
      }
      let min = 0;
      if (sec > 59) {
        min = Math.floor(sec / 60);
        sec %= 60;
      }
      return `${prefixier(min)}:${prefixier(sec)}`;
    }
  },
  data() {
    return {
      username: "",
      password: "",
      countDown: -1,
      timeout: null,
      interval: null,
      btnStatus: {
        success: false,
        loading: false,
        error: false
      },
      alertText: null
    };
  },
  computed: {},

  created() {},
  mounted() {},
  methods: {
    requestChangePassword() {
      if (this.countDown > 0) {
        return;
      }
      this.btnStatus.loading = true;
      this.alertText = "";
      clearTimeout(this.timeout);

      let data = {
        email: this.username
      };
      
      Api.base
        .post(ApiUrl.base.agency.forgotPassword, data)
        .then((res) => {
          if (!res || res.status == "error") {
            this.alertText = "Failed to request reset password";
            return
          }
          this.btnStatus.success = true;
          this.countDown = DELAY_TIME;
          clearInterval(this.interval);
          this.interval = setInterval(() => {
            this.countDown--;
            if (this.countDown < 0) {
              clearInterval(this.interval);
              this.btnStatus.success = false;
            }
          }, 1000);
          // this.timeout = setTimeout(() => {
          //   this.btnStatus.success = false;
          // }, 1500);
        })
        .catch(() => {
          this.btnStatus.error = true;
          this.alertText = "Failed to request reset password";
          this.timeout = setTimeout(() => {
            this.btnStatus.error = false;
          }, 1500);
        })
        .finally(() => {
          this.btnStatus.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .btn-default {
  min-width: 120px;
}
.floating-text {
  top: -18px;
  min-width: 120px;
  text-align: right;
}
</style>
